//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import Button from 'src/onboarding/components/ui/button/Button';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import './styles.scss';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { getBmiCategory } from 'src/onboarding/helpers/getBmiCategory';
import HealthSummaryCard from './components/HealthSummaryCard';

function Page() {
  const bmi = useStore((state) => state.bmi);
  const setBmi = useStore((state) => state.setBmi)
  const setPreferences = useStore((state) => state.setPreferences);
  const idealWeight = useStore((state) => state.idealWeight);
  const healthConcerns = useStore((state) => state.healthConcerns);
  const goForWalks = useStore((state) => state.goForWalks);
  const workOut = useStore((state) => state.workOut);
  const height = useStore((state) => state.height)
  const weight = useStore((state) => state.weight)

  const { onNext, onPrev, currentIndex } = useNav();
  const minBMI = 10;
  const maxBMI = 45;
  
  useEffect(() => {
    calculateBmi()
  }, [weight, height])

  const calculateBmi = () => {
    let weightInKg = weight.type === 'lbs' ? +weight.lbs * 0.453592 : +weight.kg;

    let heightInMeters;

    if (height.type === 'ft') {
      const [feetStr, inchesStr = '0'] = height.ft.split('.');
      const feet = parseInt(feetStr, 10);
      const inches = parseInt(inchesStr, 10);

      const totalInches = feet * 12 + (inches || 0);
      heightInMeters = totalInches * 0.0254;
    } else if (height.type === 'cm') {
      heightInMeters = +height.cm / 100;
    }

    if (heightInMeters > 0) {
      const calculatedBmi = (weightInKg / heightInMeters ** 2).toFixed(1);
      setBmi(Number(calculatedBmi));
    }
  };

  const clampedBMI = Math.max(minBMI, Math.min(bmi, maxBMI));

  const markerLeft = ((clampedBMI - minBMI) / (maxBMI - minBMI)) * 100;

  const category = getBmiCategory(bmi);

  const categoryLabel = category ? t(`onboarding.personalSummary.${category.toLowerCase()}`) : '';

  const massLevels = [
    { className: 'underweight', label: t('onboarding.personalSummary.underweight') },
    { className: 'healthy', label: t('onboarding.personalSummary.healthy') },
    { className: 'overweight', label: t('onboarding.personalSummary.overweight') },
    { className: 'obese', label: t('onboarding.personalSummary.obese') },
  ];

  const goForWalksLevels = {
    'Very active': t('onboarding.personalSummary.goForWalksLevels.veryActive'),
    'Active': t('onboarding.personalSummary.goForWalksLevels.active'),
    'Lightly active': t('onboarding.personalSummary.goForWalksLevels.lightlyActive'),
    'Low': t('onboarding.personalSummary.goForWalksLevels.low')
  }

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.personalSummary.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <div className='bmi-container'>
          <Text size='m' bold>
            {t('onboarding.personalSummary.bodyMassIndex')}
          </Text>
          <div className='bmi-index'>
            <Title tag='h5'>{bmi}</Title>
            <p className={`bmi-level ${category.toLowerCase()}`}>{categoryLabel}</p>
          </div>
          <div className='bmi-scale'>
            <div className='marker' style={{ left: `${markerLeft}%` }} />
          </div>
          <div className='mass-levels'>
            {massLevels.map(({ className, label }) => (
              <div key={className} className='mass-level'>
                <span className={className}></span>
                <Caption size='m'>{label}</Caption>
              </div>
            ))}
          </div>
        </div>
        <HealthSummaryCard
          idealWeight={idealWeight}
          goForWalks={goForWalksLevels[goForWalks]}
          healthConcerns={healthConcerns}
          workOut={workOut}
        />
      </div>

      <div className={'overlay'}></div>

      <div className={'next-wrapper'}>
        <Button
          title={t('onboarding.personalSummary.continue')}
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'personal-summary',
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
